import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { AppUpdateBannerComponent } from './core/app-version/app-update-banner.component';
import { AppVersionService } from './core/app-version/app-version.service';
import { DevelopmentContextHudComponent } from './core/development/development-context-hud.component';
import { MaintenanceBannerComponent } from './core/maintenance/maintenance-banner.component';
import { MaintenanceLockdownComponent } from './core/maintenance/maintenance-lockdown.component';
import { MaintenanceNoticeService } from './core/maintenance/maintenance-notice.service';
import { OpportunitiesService } from './features/opportunities/opportunities.service';
import { OpportunityContextNavComponent } from './features/opportunities/components/opportunity-context-nav/opportunity-context-nav.component';
import { AppSidebarUserComponent } from './shared/components/app-sidebar-user/app-sidebar-user.component';
import { ScrollEdgeService } from './shared/scroll-edge/scroll-edge.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    OpportunityContextNavComponent,
    AppUpdateBannerComponent,
    MaintenanceBannerComponent,
    MaintenanceLockdownComponent,
    DevelopmentContextHudComponent,
    AppSidebarUserComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  readonly sidebarOpen = signal(false);
  protected readonly opportunitiesService = inject(OpportunitiesService);
  protected readonly maintenanceNotice = inject(MaintenanceNoticeService);
  protected readonly activeOpportunity = this.opportunitiesService.activeOpportunity;

  constructor() {
    inject(AppVersionService).startMonitoring();
    inject(MaintenanceNoticeService).startMonitoring();
    inject(ScrollEdgeService).start();
  }

  toggleSidebar(): void {
    this.sidebarOpen.update((open) => !open);
  }

  closeSidebar(): void {
    this.sidebarOpen.set(false);
  }
}
